import { deleteCookiesAuth } from '../../../../auth/utils/cookies'
import { ROUTES } from '../../../../web-components/constants/routes'

const STAGE = process.env.STAGE

const urlRedirect = ['/properties/list', '/v2.0.2/user/pass_required_info']

export function authenticatedErrorResponseInterceptor(error: any) {
  const urlService = error?.config?.url ?? ''
  const containsPath = urlRedirect.some((url) => urlService.includes(url))
  if (error?.response?.status === 401 && containsPath) {
    if (STAGE !== 'local') {
      deleteCookiesAuth()
      window.location.href = ROUTES.AUTH_LOGIN
    }
  } else if (error?.response?.status === 403) {
    // router.push('/403')
  }

  throw error?.response
}
